// src/components/navbars/topbar/Header.tsx
import { Menu } from "react-feather";
import { Link } from "react-router-dom";
import { Nav, Navbar } from "react-bootstrap";
import Notifications from "./Notifications";

const BACKEND_ORIGIN = import.meta.env.VITE_BACKEND_ORIGIN;

interface HeaderProps {
  toggleMenu: () => void;
  logoUrl?: string | null;
}

const Header: React.FC<HeaderProps> = ({ toggleMenu, logoUrl }) => {
  return (
    <Navbar className="navbar-classic navbar navbar-expand-lg">
      <div className="d-flex justify-content-between w-100">
        <div className="d-flex align-items-center">
          <Link
            to="#"
            id="nav-toggle"
            className="nav-icon me-2 icon-xs"
            onClick={() => toggleMenu()}
          >
            <Menu size="18px" />
          </Link>

          <div className="ms-lg-3 d-none d-md-none d-lg-block">
            {/* LOGO HERE */}
            {logoUrl && (
              <img
                src={
                  logoUrl.startsWith("http")
                    ? logoUrl
                    : `${BACKEND_ORIGIN}${logoUrl}`
                }
                style={{
                  height: 60,
                  maxWidth: 1000,
                  objectFit: "contain",
                }}
              />
            )}
          </div>
        </div>

        {/* Quick Menu */}
        <Nav className="navbar-right-wrap ms-2 d-flex nav-top-wrap">
          <Notifications />
        </Nav>
      </div>
    </Navbar>
  );
};

export default Header;
